import DashboardIcon from '../assets/icons/dashboard.svg';
import ShippingIcon from '../assets/icons/shipping.svg';
import ProductIcon from '../assets/icons/product.svg';
import UserIcon from '../assets/icons/user.svg';

const sidebar_menu = [
    {
        id: 1,
        icon: DashboardIcon,
        path: '/',
        title: 'Dashboard',
    },
    {
        id: 2,
        icon: ProductIcon,
        path: '/gym-members',
        title: 'Gym Members',
    },
    {
        id: 3,
        icon: ProductIcon,
        path: '/gym-daily-members',
        title: 'Gym Daily members',
    },
    {
        id: 4,
        icon: ProductIcon,
        path: '/gym-active-members',
        title: 'Gym Active members',
    },
    {
        id: 5,
        icon: ProductIcon,
        path: '/gym-inactive-members',
        title: 'Gym InActive members',
    },
]

export default sidebar_menu;